import UtilsSchema from "@repoflow/schema/utils";
import TypesSchema from "@common/schema/types";

import {
  orgId,
  tableId,
  title,
  description,
  columns,
  sourceType,
  source,
  sourceSchema,
  sync,
  credentialHint,
  tags,
  rowCount,
  rowsEtag,
  createdAt,
  updatedAt,
} from "./fields";

export default [
  ...UtilsSchema,
  ...TypesSchema,
  // The four source branches, so the oneOf on `source` can resolve them.
  ...sourceSchema,
  {
    id: "/Public/Table",
    type: "object",
    properties: {
      orgId,
      tableId,
      title,
      description,
      columns,
      sourceType,
      source,
      sync,
      credentialHint,
      tags,
      rowCount,
      rowsEtag,
      createdAt,
      updatedAt,
    },
  },
  {
    // Deliberately narrow: you name a table and title it, then declare its
    // columns on the edit screen. Asking for a column list in a create dialog is
    // how you get a form nobody finishes — the same call wfws makes for a
    // workflow's steps.
    id: "/Public/Table/Create",
    type: "object",
    properties: {
      tableId,
      title,
      // Chosen at create because it decides what the table's own screen looks
      // like, and because switching a table that already has rows from one
      // source to another is a different operation with a different question to
      // ask ("and what happens to what is in it?"). Defaults to `system`.
      sourceType,
      tags,
    },
    // Mirrors TableInputCreate's non-null fields exactly. An empty `required`
    // array is what left assertValid unable to reject anything in the project
    // this shape came from (A9 in docs/datum-api.md).
    required: ["tableId", "title"],
  },
  {
    // `tableId` is absent on purpose: it is the range key, so an input field for
    // it would read as a rename and would in fact write a second row, leaving
    // the first orphaned — and every saved view naming the old id would break.
    //
    // `rowCount` and `rowsEtag` are absent for a different reason: they are what
    // S3 said, not what a caller may assert.
    id: "/Public/Table/Update",
    type: "object",
    properties: {
      title,
      description,
      columns,
      // `sourceType` and `source` travel together: the first selects the oneOf
      // branch the second is validated against, so a form that could change one
      // without the other would be able to submit a shape nothing accepts.
      sourceType,
      source,
      tags,
    },
    // `sync` and `credentialHint` are absent: both are what the SERVER last did,
    // not what a caller may assert.
    required: ["title"],
  },
];
